import {
  addBreadcrumb,
  browserTracingIntegration,
  captureException,
  init,
  replayIntegration,
  setUser,
} from '@sentry/browser';
import type { TSdk } from '#observability/observability.types.ts';
import type { TSentryOptions } from './sentry.types.ts';

const TRACES_SAMPLE_RATE = 0.1;
const REPLAYS_SESSION_SAMPLE_RATE = 0.1;
const REPLAYS_ON_ERROR_SAMPLE_RATE = 1;
const ignoredErrors = [
  /Can't find variable: cordova/,
  /Object Not Found Matching Id/,
];

const deniedUrls = [/e-js\.zonka\.co/];

const sentrySdk: TSdk = {
  identify: ({ userId, traits }) => setUser({ ...traits, id: userId }),
  anonymize: () => setUser(null),
  track: (name, properties) => {
    addBreadcrumb({
      category: 'event',
      message: name,
      data: properties,
      level: 'info',
    });
  },
  reportError: (error, context) => {
    captureException(error, {
      tags: { source: context.source },
      extra: { ...context },
    });
  },
};

export const initSentry = ({
  dsn,
  environment,
  release,
}: TSentryOptions): TSdk => {
  init({
    dsn,
    environment,
    release,
    integrations: [browserTracingIntegration(), replayIntegration()],
    tracesSampleRate: TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: REPLAYS_ON_ERROR_SAMPLE_RATE,
    ignoreErrors: ignoredErrors,
    denyUrls: deniedUrls,
  });

  return sentrySdk;
};
